// extracted by mini-css-extract-plugin
export default {"hwaFooter":"HWAFooter_hwaFooter__EcAXV","horzList":"HWAFooter_horzList__+MKvm"};